import _ from 'lodash';

export default function selector(storeState) {
    const draft = _.get(storeState, 'adminOrgForm.draft');
    return {
        draft,
    };
}
